import { Pipe, PipeTransform } from '@angular/core';
import { EventCartItems } from 'src/models/eventAttendee';
import { EventAddon, EventPricesWithAddons } from 'src/models/events';

@Pipe({
    name: 'filterByAddonsType',
    pure: false
})
export class FilterByAddonsType implements PipeTransform {
    transform(items: EventPricesWithAddons[], type: string): EventPricesWithAddons[] {
        return type && items ? items.filter(item => item.EventItemPriceTypeName?.toLowerCase() === type?.toLowerCase()) : items;
    }
}


@Pipe({
    name: 'filterByCategoryId',
    pure: false
})
export class FilterByCategoryId implements PipeTransform {
    transform(items: EventAddon[], type: number): EventAddon[] {
        return type && items ? items.filter(item => item.EventItemPriceCategoryId === type) : items;
    }
}

@Pipe({
    name: 'filterByCartItems',
    pure: false
})
export class FilterByCartItems implements PipeTransform {
    transform(items: EventCartItems[], type: string): EventCartItems[] {
        return type && items ? items.filter(item =>
            item.EventItemPriceTypeName?.toLowerCase() === type?.toLowerCase()) : items;
    }
}